import { safeStorage } from "../storage";

const localStorageHook = {
  mounted() {
    const localStorage = safeStorage("localStorage");
    // Migrate isMobileApp from localStorage to cookie (one-time migration for old clients)
    if (localStorage.getItem("isMobileApp") === "true") {
      this.setCookie("isMobileApp", "true", 365);
      localStorage.removeItem("isMobileApp");
    }

    // Renew cookie if already set (keeps it from expiring on active users)
    if (this.getCookie("isMobileApp") === "true") {
      this.setCookie("isMobileApp", "true", 365);
    }

    this.pushEvent("os", { os: this.getOS() });
  },
  getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)"),
    );
    return match ? decodeURIComponent(match[2]) : null;
  },
  setCookie(name, value, days) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
  },
  getOS() {
    let os = "unknown";

    const userAgent = window.navigator.userAgent;
    const platform =
      window.navigator?.userAgentData?.platform || window.navigator.platform;
    const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
    const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
    const iosPlatforms = ["iPhone", "iPad", "iPod"];

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (/Linux/.test(platform)) {
      os = "Linux";
    }

    return os;
  },
};

export default localStorageHook;
